
define('ldsh!modules/country/list/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>Country</h1>\n<a class="btn btn-default" href="#/country/create">Create</a>\n<table class="table table-striped">\n\t<thead>\n  \n  <th>\n   Code\n  </th>\n  \n  <th>\n   Name\n  </th>\n\n  <th>\n\n  </th>\n    <th>\n\n  </th>\n\t</thead>\n\t<tbody class="Country-body">\n\t</tbody>\n</table>';

}
return __p
};});

